// Import Libraries
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';

import VueCookies from "vue3-cookies";

import BootstrapVueNext from "bootstrap-vue-next";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export const registerLibraries = (app) => {
  app.use(BootstrapVueNext);
  app.use(PerfectScrollbarPlugin);
  app.use(VueCookies, {
    expireTimes: "1d",
    path: "/",
    domain: "",
    secure: true,
    sameSite: "None",
  });
  app.use(Vue3Toasity);

  return app;
};
